module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gamelist-template"
  }, [_c('table-data', {
    staticClass: "games",
    attrs: {
      "items": _vm.games
    },
    on: {
      "select": _vm.selectGame,
      "remove": _vm.removeGame
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(props) {
        return _c('game-cell', {
          attrs: {
            "cell-data": props.itemdata,
            "cell-index": props.itemindex
          }
        })
      }
    }])
  }), _vm._v(" "), _c('button', {
    staticClass: "button color-blue-500 start-button",
    on: {
      "click": function($event) {
        _vm.startGame()
      }
    }
  }, [_vm._v("Nouvelle partie")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4acbf27d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GameList.vue
// module id = 110
// module chunks = 2